import { useHydration } from "@puregym/react-hooks";
import { Button, BUTTON_VARIANTS, Modal } from "@puregym/ui";
import { useEffect, useState } from "react";
import { useGymSearchState } from "../../../context";
import { getPluralLabel } from "../../../utilities/helpers";
import labels from "../../labels";

const SearchModal = () => {
  const enabled = useHydration();
  const [isResultModalOpen, setResultModalOpen] = useState(false);
  const { searchSuccessfullyPerformed, numSearchResults, noGymsFoundInRange } =
    useGymSearchState();

  //Display the modal if a search has been completed
  useEffect(() => {
    if (searchSuccessfullyPerformed) {
      setResultModalOpen(true);
    }
  }, [searchSuccessfullyPerformed, numSearchResults]);

  const gymsFound = getPluralLabel(
    labels.gymFinder.gymsFoundNearby,
    numSearchResults,
    new Map([["resultCount", numSearchResults]])
  );

  //Search modal text depends on whether any gyms were nearby
  const SearchModalText = () => {
    const searchText = noGymsFoundInRange
      ? labels.gymFinder.noGymsFoundNearby
      : gymsFound;

    return <p>{searchText}</p>;
  };

  return (
    <Modal
      isOpen={isResultModalOpen}
      onClose={() => setResultModalOpen(false)}
      headingText={labels.gymFinder.searchResults}
      closeText={labels.shared.core.closeMenuButton}
    >
      <SearchModalText />
      <Button
        variant={BUTTON_VARIANTS.PRIMARY}
        disabled={!enabled}
        onClick={() => setResultModalOpen(false)}
      >
        {labels.ok}
      </Button>
    </Modal>
  );
};

export default SearchModal;
